import { MODULE_ROUTE, PATHNAME_MODULE_MAP } from './constant';
import type { SentryModule } from './types';

export { MODULE_ROUTE, PATHNAME_MODULE_MAP } from './constant';

export const defaultRouteHints = (
  module: SentryModule,
  override?: readonly string[],
): readonly string[] => override ?? [MODULE_ROUTE[module]];

export const routeMatches = (
  routeOrPathname: string,
  routeHints?: readonly string[],
): boolean => {
  if (!routeHints?.length) return true;
  const haystack = routeOrPathname.toLowerCase();
  return routeHints.some(hint => haystack.includes(hint.toLowerCase()));
};

export const moduleFromPathname = (
  pathname?: string | null,
): SentryModule | undefined => {
  if (!pathname) return undefined;
  return PATHNAME_MODULE_MAP.find(({ prefix }) => pathname.includes(prefix))
    ?.module;
};
